/*
 *  I04CALCULGSIMPI18n.js
 *
 *  Created by Sébastien Hecart on 2019-05-12 21:46:33 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I04CALCULGSIMP_SECTION_0_TITLE: 'Types de paroies',
  I04CALCULGSIMP_umurext: 'U des murs extérieurs',
  I04CALCULGSIMP_vitrage: 'Vitrage',
  I04CALCULGSIMP_plafond: 'Plafond',
  I04CALCULGSIMP_plancher: 'Plancher',
  I04CALCULGSIMP_configuration: 'Configuration',
  I04CALCULGSIMP_SECTION_1_TITLE: 'Résultat',
  I04CALCULGSIMP_res_coeffDepVol: 'Coefficient de déperditions volumiques'
}
